import { render, staticRenderFns } from "./MallOrder.vue?vue&type=template&id=42df77ee"
import script from "./MallOrder.vue?vue&type=script&lang=js"
export * from "./MallOrder.vue?vue&type=script&lang=js"
import style0 from "./MallOrder.vue?vue&type=style&index=0&id=42df77ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports